module.exports = __webpack_public_path__ + "assets/ic-telegram.e3b0c8ed.svg";